"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerDiv = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.ContainerDiv = styled_1.default.div `
  .chatbot-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10000;
    background-color: rgba(25, 58, 86, 0.85);

    .chatbot-container{
      margin: 16px 24px;
      border-radius: 16px;
      height: calc(100% - 32px);
      overflow: hidden;
      @media (min-width: 768px){
        margin-left: auto;
        margin-right: auto;
        max-height: 1137px;
        max-width: 672px;
      }

      @media (min-width: 1080px){
        max-width: 95%;
      }
      @media (min-width: 1312px){
        max-width: 980px;
        width: 90%;
        height: 90%;
        margin-top: 30px;
      }
    }
    
    &.hidden{
      display: none;
    }
    
    &.visible{
      display: block;
    }
  }
`;
